import { isType } from "typescript-fsa";
import { PropertyState } from "./types";
import { propertyActions } from "./actions";
import { Action } from "@reduxjs/toolkit";

const initialState: PropertyState = {
  commercial: null,
  residential: null,
  detail: null
};

export function PropertyReducer(
  state = initialState,
  action: Action
): PropertyState {
  if (isType(action, propertyActions.getCommercialList.done)) {
    return {
      ...state,
      commercial: action.payload.result,
    };
  }

  if (isType(action, propertyActions.getResidentailList.done)) {
    return {
      ...state,
      residential: action.payload.result,
    }
  }

  if (isType(action, propertyActions.propertyDetail.done)) {
    return {
      ...state,
      detail: action.payload.result,
    }
  }

  if (isType(action, propertyActions.resetToIntialState)) {
      return initialState;
    }

  return state;
}
